import type { ChatConversation, ChatMember, ChatRole, DeliveryState } from '../api/types'

export type OtherSideCursors = { delivered: number | null; read: number | null }

export const NO_CURSORS: OtherSideCursors = { delivered: null, read: null }

export function otherSideMembers(
  members: ChatMember[],
  myRole: ChatRole,
  myUserId: number | null,
  internal: boolean,
): ChatMember[] {
  return internal
    ? members.filter((member) => member.userId != null && member.userId !== myUserId)
    : members.filter((member) => member.role !== myRole)
}

export function cursorsFor(others: ChatMember[]): OtherSideCursors {
  if (others.length === 0) return NO_CURSORS
  const max = (pick: (member: ChatMember) => number | null): number | null =>
    others.reduce<number | null>((best, member) => {
      const value = pick(member)
      if (value == null) return best
      return best == null || value > best ? value : best
    }, null)
  return { delivered: max((m) => m.lastDeliveredMessageId), read: max((m) => m.lastReadMessageId) }
}

export function deliveryStateForMessage(messageId: number, cursors: OtherSideCursors): DeliveryState {
  if (cursors.read != null && cursors.read >= messageId) return 'read'
  if (cursors.delivered != null && cursors.delivered >= messageId) return 'delivered'
  return 'sent'
}

export function conversationRowState(
  conversation: ChatConversation,
  myUserId: number | null,
  hasFailedSend: boolean,
): DeliveryState | null {
  if (hasFailedSend) return 'failed'
  if (myUserId == null) return null
  if (conversation.lastMessageSenderUserId !== myUserId) return null
  if (conversation.lastMessageId == null) return null
  if (conversation.lastMessageRead) return 'read'
  if (conversation.lastMessageDelivered) return 'delivered'
  return 'sent'
}
